import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Newsletter from '../components/Newsletter';

const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <Newsletter />
    </div>
  );
};

export default Home;
